import React, { useState } from 'react';
import qrImage from '../assets/qr.png';
import sewingImage from '../assets/Sewing.png';
import bnbIcon from '../assets/BNBicon.png';

export default function WalletModal({ isOpen, onClose }) {
  const [activeTab, setActiveTab] = useState('Mobile');

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Базовые размеры модального окна
  const baseWidth = 660;
  const baseHeight = activeTab === 'Mobile' ? 640 : 590;
  const baseScreenWidth = 1920;
  
  // Вычисляем масштаб относительно ширины экрана
  const scale = window.innerWidth / baseScreenWidth;
  
  // Применяем масштаб к размерам
  const modalWidth = baseWidth * scale;
  const modalHeight = baseHeight * scale;

  return (
    <div 
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div 
        className="bg-[#191919] rounded-[30px] border border-[#414141] relative"
        style={{
          width: `${modalWidth}px`,
          height: `${modalHeight}px`,
          minWidth: '660px',
          minHeight: activeTab === 'Mobile' ? '640px' : '590px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Красная шапка */}
        <div
          className="absolute"
          style={{
            top: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '140px',
            backgroundColor: '#520001',
            borderTopLeftRadius: '30px',
            borderTopRightRadius: '30px'
          }}
        />

        {/* Sewing Barcode - сверху по центру в красной шапке */}
        <div
          className="absolute"
          style={{
            left: '50%',
            top: '0px',
            transform: 'translateX(-50%)',
            width: '400px',
            height: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src={sewingImage}
            alt="Sewing Barcode"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>

        

        {/* Mobile Tab */}
        <button
          onClick={() => setActiveTab('Mobile')}
          className="absolute cursor-pointer"
          style={{
            left: '211px',
            top: '167px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: '18px',
            color: activeTab === 'Mobile' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(255, 255, 255, 0.4)',
            background: 'none',
            border: 'none',
            padding: 0
          }}
        >
          Mobile
        </button>

        {/* WebApp Tab */}
        <button
          onClick={() => setActiveTab('WebApp')}
          className="absolute cursor-pointer"
          style={{
            left: '383px',
            top: '167px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: '18px',
            color: activeTab === 'WebApp' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(255, 255, 255, 0.4)',
            background: 'none',
            border: 'none',
            padding: 0
          }}
        >
          WebApp
        </button>

        {/* Синяя линия под активной вкладкой */}
        <div
          className="absolute"
          style={{
            left: activeTab === 'Mobile' ? '200px' : '380px',
            top: '203px',
            width: '80px',
            height: '4px',
            backgroundColor: '#356DFD',
            borderRadius: '4px 4px 0 0'
          }}
        />

        {/* Разделительная линия под вкладками */}
        <div
          className="absolute"
          style={{
            left: '190px',
            top: '207px',
            width: '280px',
            height: '1px',
            backgroundColor: 'rgba(217, 217, 217, 0.3)',
            borderRadius: '4px'
          }}
        />

        {/* Mobile Tab Content */}
        {activeTab === 'Mobile' && (
          <>
            {/* QR Code */}
            <div
              className="absolute"
              style={{
                left: '210px',
                top: '240px',
                width: '240px',
                height: '240px'
              }}
            >
              <img
                src={qrImage}
                alt="QR Code"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>

            {/* Текст под QR кодом */}
            <p
              className="absolute text-center"
              style={{
                left: '171px',
                top: '493px',
                width: '318px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.6)',
                margin: 0
              }}
            >
              Scan QR-core with you phone application
            </p>
          </>
        )}

        {/* WebApp Tab Content */}
        {activeTab === 'WebApp' && (
          <>
            {/* BNB Icon */}
            <div
              className="absolute"
              style={{
                left: '50%',
                top: '240px',
                transform: 'translateX(-50%)',
                width: '110px',
                height: '110px'
              }}
            >
              <img
                src={bnbIcon}
                alt="BNB Icon"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>

            {/* Open App Button */}
            <button
              className="absolute cursor-pointer"
              style={{
                left: '50%',
                top: '375px',
                transform: 'translateX(-50%)',
                width: '169px',
                height: '40px',
                backgroundColor: 'rgba(53, 109, 253, 0.15)',
                border: '1px solid #356DFD',
                borderRadius: '8px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0
              }}
            >
              Open App
            </button>

            {/* Текст под кнопкой */}
            <p
              className="absolute text-center"
              style={{
                left: '50%',
                top: '435px',
                transform: 'translateX(-50%)',
                width: '500px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.4)',
                margin: 0,
                lineHeight: '1.4'
              }}
            >
              Binance Wallet web app has opened in a new tab. Go there, accept the connection, and come back.
            </p>
          </>
        )}

        {/* Текст внизу - Terms of Use */}
        <p
          className="absolute text-center"
          style={{
            left: '50%',
            top: activeTab === 'Mobile' ? '585px' : '535px',
            transform: 'translateX(-50%)',
            width: '510px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.4)',
            margin: 0
          }}
        >
          By proceeding, you agree to Terms of Use & Privacy Policy.
        </p>
      </div>
    </div>
  );
}

